import { useMemo } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, type StripeElementsOptions } from '@stripe/stripe-js';

import { type StripePaymentProviderProps } from '../../types';

export const StripePaymentProvider = (props: StripePaymentProviderProps) => {
  const { children, amount, sessionId, publicKey } = props;

  const stripePromise = useMemo(() => loadStripe(publicKey), [publicKey]);

  const options = useMemo<StripeElementsOptions>(
    () => ({
      amount: Math.max(amount, 100),
      currency,
      mode,
      paymentMethodCreation,
      customerSessionClientSecret: sessionId,
    }),
    [amount, sessionId],
  );

  return (
    <Elements stripe={stripePromise} options={options}>
      {children}
    </Elements>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const currency = 'usd';
const mode = 'payment';
const paymentMethodCreation = 'manual';
